import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as domain from '@common/domain/entities/User';
import * as JobDTO from '@common/domain/models/JobDTO';
import * as models from '@common/domain/models/UserDTO';
import { appSettings } from '@shared/components/appSettings';
import { IApiServiceCommand } from '@services/api/api.service';
import { ViewType, FieldType } from '../../../framework/core/Enums';

export class UserEndpoints extends domain.UserEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/" + serviceCommand.context.entityId
    }
  };
  search?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/user/search/", method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: app.config.controllerRouteRoot + "/user/searchCount/", method: "POST" };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/update/" + serviceCommand.context.entityId
    },
    method: 'post'
  };
  insert?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/create/"
    },
    method: 'post'
  };
}

export class CurrentUserEndpoints extends domain.UserEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/forUser/"
    }
  };
  update?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/user/updateForUser/"
    },
    method: 'post'
  };
}

export class UserRoleJobsEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/User/roleJobs",
    //url: app.config.controllerRouteRoot + "/organisation/getUsers/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId
      }
    }
  };
}


export class OrganisationUserEndPoints implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/organisation/users",
    //url: app.config.controllerRouteRoot + "/organisation/getUsers/{context.parent.parent.selectedItem.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        organisationId: serviceCommand.context.entityId
      }
    },
    method: "POST"
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/organisation/addUser",
    //url: app.config.controllerRouteRoot + "/organisation/addUser?organisationId={context.parent.parent.selectedItem.id}&userId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        organisationId: serviceCommand.context.entityId,
        userId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/organisation/removeUser",
    //url: app.config.controllerRouteRoot + "/organisation/removeUser?organisationId={context.parent.parent.selectedItem.id}&userId={data.id}"",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        organisationId: serviceCommand.context.entityId,
        userId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}


export class UserListColumns extends domain.UserListColumns {
  constructor() {
    super();
    this.splice(0, this.length)
    this.push({ field: 'id', visible: false });
    this.push(this.email);
    this.push(this.firstname);
    this.push(this.lastname);
    this.push(this.phoneNumber);
  }
}
export class UserList extends domain.UserList {
  protected userListEndPoints: UserEndpoints = new UserEndpoints();
  protected userListColumns: UserListColumns = new UserListColumns();
}

export class UserFormFields extends domain.UserFormFields {

  constructor() {
    super();
    let file: IFieldOptions = {
      field: "signatureFileCabinet", required: false, viewType: ViewType.File, fieldType: FieldType.String, name: "Signature Upload", dataDisplayField: "fileName", dataIdField: "signatureFileCabinetId",
      dataEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/download/", method: "POST" },
      insertEndPoint: { url: appSettings.apiServiceAddress + "/api/filecabinetDocument/uploadNewFiles", method: "POST" },
    };

    this.splice(0, this.length);
    this.push(this.userName);
    this.push(this.firstname);
    this.push(this.lastname);
    this.push(this.password);
    this.push(this.confirmPassword);
    this.push(this.sisproPrefix);
    this.push(file);
    this.password.show = function (scope) {
      return scope.entityId = '00000000-0000-0000-0000-000000000000';
    }
    this.confirmPassword.show = function (scope) {
      return scope.entityId = '00000000-0000-0000-0000-000000000000';
    }
  }
}

export class OrganisationUserListColumns extends Array<IColumnOptions> {
  public selected: IColumnOptions = { field: "selected", width: "140px" };
  public displayName: IColumnOptions = { field: "displayName" };
  constructor() {
    super();
    this.push(this.selected);
    this.push(this.displayName);
    this.selected.readOnly = false;
    this.selected.endPoints = new OrganisationUserEndPoints();

  }
}

export class OrganisationUserListSetup implements IGridOptions {
  protected organisationUserListName: string = "organisationUserList";
  protected organisationUserListModel: models.UserDTO = new models.UserDTO();
  protected organisationUserListEndPoints: domain.UserEndPoints = new domain.UserEndPoints();
  protected organisationUserListColumns: OrganisationUserListColumns = new OrganisationUserListColumns();
  public userForm: UserForm = new UserForm();
  public get name(): string { return this.organisationUserListName };
  public get model(): models.UserDTO { return this.organisationUserListModel };
  public get endPoints(): IEntityEndPoints { return this.organisationUserListEndPoints };
  public set endPoints(userEndPoints: IEntityEndPoints) {
    this.organisationUserListEndPoints = userEndPoints;
    this.userForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): OrganisationUserListColumns { return this.organisationUserListColumns };
}

export class UserForm extends domain.UserForm implements IFormOptions {
  public get displayName(): string { return "displayName" };
  protected userFormEndPoints: UserEndpoints = new UserEndpoints();
  protected userFormFields: UserFormFields = new UserFormFields();
  public canDelete?: boolean = true;
}

export class CurrentUserForm extends domain.UserForm implements IFormOptions {
  public get displayName(): string { return "displayName" };
  protected userFormEndPoints: CurrentUserEndpoints = new CurrentUserEndpoints();
  protected userFormFields: UserFormFields = new UserFormFields();
}

export class OrganisationUserList extends OrganisationUserListSetup implements IGridOptions {
  protected organisationUserListEndPoints: OrganisationUserEndPoints = new OrganisationUserEndPoints();
  protected organisationUserListColumns: OrganisationUserListColumns = new OrganisationUserListColumns();
}

export class UserRoleJobListColumns extends Array<IColumnOptions> {
  public number: IColumnOptions = { field: "number" };
  constructor() {
    super();
    this.push(this.number);
  }
}


export class UserRoleJobList implements IGridOptions {
  protected useRoleJobListName: string = "organisationUserList";
  protected useRoleJobListModel: JobDTO.JobDTO = new JobDTO.JobDTO();
  protected useRoleJobListEndPoints: UserRoleJobsEndPoints = new UserRoleJobsEndPoints();
  protected useRoleJobListColumns: UserRoleJobListColumns = new UserRoleJobListColumns();
  public userForm: UserForm = new UserForm();
  public get name(): string { return this.useRoleJobListName };
  public get model(): JobDTO.JobDTO { return this.useRoleJobListModel };
  public get endPoints(): IEntityEndPoints { return this.useRoleJobListEndPoints };
  public set endPoints(userEndPoints: IEntityEndPoints) {
    this.useRoleJobListEndPoints = userEndPoints;
    this.userForm.endPoints = this.endPoints;
  };
  public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
  public get columns(): UserRoleJobListColumns { return this.useRoleJobListColumns };
}



